import React from 'react';
import {Color} from "../Color";
import {currencyConverter} from "../../../utility/methods";
import {getVehicleImage} from "../compare.method";
import {Change} from "../Change";

const PrimaryVehicle = ({
                         changeHandler,
                         vehicleData,
                         setVehicleData,
                         openModal,
                         setOpenModal,
                         secondaryYear,
                         vehiclesMakes,
                         vehicleModel,
                         trimModel,
                         setTrimModel,
                         setVehicleModel,
                         setVehicleMake,
                         vehiclesTrim,
                         vehicleIndex,
                         vehicleTypeName,
                         driveType,
                         setDriveType,
                         isLocked,
                         handleReload,
                         activeLocale,
                         handleChangeModalClose,
                         setPrimaryAndSecondaryVehicles,
                         hideImages,
                         hideButtons,
                         t,
                         headerLoadType
                     }) => {

    const vehicleCTA = "https://www.jdpower.com/cars-for-sale/make-"+ setPrimaryAndSecondaryVehicles[0]?.make.toLowerCase() + "/model-" + setPrimaryAndSecondaryVehicles[0]?.model.toLowerCase().replace(/ /g, "-")

    return (
        <React.Fragment>
            { (
                <div className={`primary-vehicle${hideImages ? ' images-hidden' : ''}`}>
                    <div className={`overviewPanel${setPrimaryAndSecondaryVehicles?.length ? '' : ' no-primary-selected'}`}>
                        {setPrimaryAndSecondaryVehicles[0] ? (
                            <div className={"vehicle-detail"}>
                                <div className={"model-year-make"}>
                                    {setPrimaryAndSecondaryVehicles[0]?.year}{" "}
                                    {setPrimaryAndSecondaryVehicles[0]?.make}
                                </div>
                                <div className={"vehicle-trim"}>
                                    {setPrimaryAndSecondaryVehicles[0]?.model}{" "}
                                    {setPrimaryAndSecondaryVehicles[0]?.trim}
                                </div>
                                <div className={"model-year-make"}>
                                    {t('overview.startingFrom')}
                                </div>
                                {setPrimaryAndSecondaryVehicles[0] && (
                                    <div className={"vehicle-trim"}>
                                        {currencyConverter(
                                            setPrimaryAndSecondaryVehicles[0]?.pricing.msrp, activeLocale
                                        )}
                                        <span>*</span>
                                    </div>
                                )}
                                {headerLoadType != null && (
                                    <div className={"vehicle-CTA"}>
                                        <a target="_blank" href={vehicleCTA}>See Cars For Sale</a>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className={"no-primary-vehicle"}>
                                {t('overview.controls.noVehicleSelect')}
                            </div>
                        )}
                        {getVehicleImage(setPrimaryAndSecondaryVehicles[0], activeLocale)}
                    </div>

                    <div
                        className={`vehicleController${hideButtons ? ' buttons-hidden' : ''}
                        ${!setPrimaryAndSecondaryVehicles[0] && headerLoadType === 'jdpa' ? 
                            ' no-primary-selected-jdpa' : ''}`}
                    >
                        <div className={`change-modal ${headerLoadType === 'jdpa' && !setPrimaryAndSecondaryVehicles[0] ? 'change-modal-jdpa' : ''}`}>
                            <button
                                id={0}
                                className={"btn-default btn-change-compare"}
                                value={setPrimaryAndSecondaryVehicles[0]}
                                data-testid="close-modal"
                                onClick={(event) => changeHandler(0, setPrimaryAndSecondaryVehicles[0])}
                            >
                               <span> {setPrimaryAndSecondaryVehicles[0] ?
                                   t('overview.changeSelectModal.change') : t('overview.controls.selectVehicle')
                               } </span>
                            </button>
                            <Change vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    setOpenModal={setOpenModal}
                                    handleModalClose={handleChangeModalClose}
                                    years={secondaryYear}
                                    vehicleMake={vehiclesMakes}
                                    vehicleModels={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleModel={setVehicleModel}
                                    setVehicleMake={setVehicleMake}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName={vehicleTypeName}
                                    driveType={driveType}
                                    setDriveType={setDriveType}
                                    lockedVehicle={isLocked}
                                    onReload={handleReload}
                            />
                        </div>
                        { setPrimaryAndSecondaryVehicles[0] && <div className="color-box-controller">
                            <Color
                                primaryColor={
                                    setPrimaryAndSecondaryVehicles[0]?.colors?.exteriors
                                }
                                translate={t}
                                mediaColor={setPrimaryAndSecondaryVehicles[0]?.currentColor}
                                id={0}
                                interiorColor={setPrimaryAndSecondaryVehicles[0]?.colors?.interiors}
                            />
                        </div>
                        }
                    </div>
                </div>
            ) }

        </React.Fragment>
    );
};

export default PrimaryVehicle;
